import React from 'react';
import type ServicedeskQueuesAddonViewType from '@atlassian/jira-spa-apps-servicedesk-queues-addon-view/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskQueuesAddonView = lazyForPaint<typeof ServicedeskQueuesAddonViewType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-addon-view", jiraSpaEntry: "async-servicedesk-queues-addon-view" */ '@atlassian/jira-spa-apps-servicedesk-queues-addon-view'
		),
);

type Props = RouteContext;

const AsyncServicedeskQueuesAddonView = ({ match }: Props): React.JSX.Element => {
	const addonKey = (match.params && match.params.addonKey) || '';
	return (
		<LazyPage
			Page={LazyServicedeskQueuesAddonView}
			pageId={`spa-apps/servicedesk/queues/addon/${addonKey}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskQueuesAddonView;
